import $ from "jquery"
import bluebird from "bluebird"
import Canvas from "./interface/canvas"
import Cookies from "js-cookie"
import Hook from "./hook"
import NotificationQueue from "./interface/notificationQueue"
import Session from "./model/session"
import packageConfig from "../package"
import * as Sentry from "@sentry/browser"
import {Integrations} from "@sentry/tracing"

const {notify} = require("./util/notify")
const introjs = require("./../node_modules/intro.js/intro")

console.log({frontEndVersion: packageConfig.version})

Sentry.init({
  dsn: "https://d8434bba94fb47a88a1c18a57beaa057@sentry.rentmagic.net/13",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  maxValueLength: 5000,
  tracesSampleRate: 1.0,
})

// Create session and canvas
/**
 * Global session object
 * @type {Session}
 * @global
 */
let session = new Session(String())
let canvas = new Canvas(session)
session.canvas = canvas

// Set session globally
global.session = session

// Set hook globally
global.hook = Hook

// Set jquery globally
global.$ = $

// Set introjs globally
global.introjs = introjs

global.online = true

// Initialize the modals (Small, Medium, Large and extra large variants)
// Modals are in the index.html, bootstrap native takes care of setting modal content,
// and hiding/showing the modals

const extraLargeModal = document.getElementById("extraLargeModal")
const largeModal = document.getElementById("largeModal")
const mediumModal = document.getElementById("mediumModal")
const smallModal = document.getElementById("smallModal")

/**
 * Create global ES6 promise
 * @private
 * @returns {void}
 */
function initiatePromise() {
  /**
   * Global promise class
   * @type {Promise}
   * @global
   */
  global.Promise = bluebird
  // global.nunjucks = require("nunjucks")

  bluebird.onPossiblyUnhandledRejection(err => {
    console.error(err)
    throw err
  })

  bluebird.onUnhandledRejectionHandled(err => {
    console.error(err)
    throw err
  })
}

/**
 * Enable password viewer
 * @private
 * @returns {void}
 */
function enablePasswordViewer() {
  $(document)
    .on("mousedown", ".login .show-password", function() {
      $(this)
        .closest(".form-element")
        .find("input")
        .prop("type", "text")
    })
    .on("mouseup mouseleave", ".login .show-password", function() {
      $(this)
        .closest(".form-element")
        .find("input")
        .prop("type", "password")
    })
}

/**
 * Save current environment in cookie, to be used in website
 * @private
 * @returns {void}
 */
function setEnvironmentCookie() {
  let url = window.location.hostname
  let parts = url.split(".").reverse()
  let domain = parts[1] + "." + parts[0]
  const EXP_MAX = Math.pow(2, 31) - 1

  let str = Cookies.get("live_envs") || ""

  if (str.indexOf(parts[2]) == -1) {
    if (str) {
      str += "|"
    }

    str += parts[2]

    Cookies.set("live_envs", str, {
      expires: EXP_MAX,
      domain: "." + domain,
    })
  }
}

/**
 * Load banner
 * @private
 * @returns {void}
 */
function load() {
  let image = new Image()
  image.src = "./App_Themes/images/banner.jpg"
  image.onload = () => {
    $("body").addClass("loaded")
  }
}

// Startup logic
initiatePromise()
enablePasswordViewer()
setEnvironmentCookie()
load()

/**
 * Unpack requires
 * @private
 * @param {Object} req - Requires
 * @param {function} wrap - Wrap function
 * @returns {Object} output
 */
function unpackReq(req, wrap) {
  let out = {}

  req.keys().forEach(key => {
    let name = key.replace(/^\.\//, "").replace(/\.\w+$/, "")
    out[name] = req(key)
  })

  return wrap ? wrap(out) : out
}

// Import all hooks in ./hooks/*.js and in ./hooks/PRODUCT/**/*.js
unpackReq(require.context("./hooks", false, /\.js$/i))
unpackReq(require.context("./hooks/" + process.env.PRODUCT, true, /\.js$/i))

async function notificationCheckTimer() {
  if (global.session.product !== "Cartfinity") {
    let notificationID = 0
    let notificationQueue = new NotificationQueue(notificationID)

    // Interval of 5 sec for fetching notifications.
    window.setInterval(async () => {
      if (
        global.session.username &&
        global.session.currentUser &&
        global.session.currentUser.AcceptNotification
      ) {
        await notificationQueue.render()
        notificationID = notificationQueue.getNotificationID()
      }
    }, 15000)
  }
}

// Start notification checker
notificationCheckTimer()
